<div class="container">
  <div class="title">Спасибо, что прошли {{testType === 'POLL' ? 'опрос' : 'тест'}}!</div>
</div>
